const BLOCK_ID_MAP = {
  blockOne: 27,
  blockTwo: 28,
  blockThree: 29,
  blockFour: 30,
  blockFive: 31,
  blockSix: 32,
  blockSeven: 33,
  blockEight: 34,
};

export default BLOCK_ID_MAP;
